module.exports = __webpack_public_path__ + "img/marker_office.527c0de6.png";